import { render, staticRenderFns } from "./singIn.vue?vue&type=template&id=1f67bbb5&"
import script from "./singIn.vue?vue&type=script&lang=js&"
export * from "./singIn.vue?vue&type=script&lang=js&"
import style0 from "./singIn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports